<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Dispensa de Subestoques'"
      :newRowmodalButtonText="'Nova Dispensa'"
      :tableHeader="headers"
      :tableRows="listaDeDispensasSubestoques"
      :isView="true"
      :isEdit="false"
      :isFinish="false"
      :isDel="false"
      :isPrint="true"
      :totalItens="totalDispensa"
      v-on:datatable-newrow="modalInsert"
      v-on:datatable-viewrow="modalView"
      v-on:datatable-print="imprimir"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable v-show="showSkeletonTable == true" :showSkeletonTable="showSkeletonTable"></SkeletonTable>

    <TipoImpressao :showModal="modalImpressao.modalAberta" v-on:close-modal="modalImpressao.modalAberta = false" v-on:event-gerar-pdf="gerarPDF(modalImpressao.conteudo)" v-on:event-gerar-nota="gerarNota(modalImpressao.conteudo)" />

    <Loading :open="loading" />

    <ModalCustomSize
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="insert"
    >
      <div v-if="!modalCustomSize.isView">
        <v-form v-model="isFormValid">
          <v-row cols="12">
            <v-col cols="12">
              <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
            </v-col>

            <v-expand-transition>
              <v-col cols="12">
                <v-autocomplete label="Dispensar para Subestoques" :items="listaDeSubestoques" v-model="subestoqueSelecionado" :readonly="modalCustomSize.isView" :rules="[rules.required]"></v-autocomplete>
              </v-col>
            </v-expand-transition>

            <v-col cols="12">
              <v-checkbox label="Dispensar Kit" v-model="dispensaKit" :value="true"></v-checkbox>
            </v-col>

            <v-expand-transition>
              <v-col cols="12" v-if="dispensaKit">
                <v-autocomplete label="Lista de Kits" :items="listaDeKits" v-model="kitSelecionado"></v-autocomplete>
              </v-col>
            </v-expand-transition>

            <v-expand-transition>
              <v-col cols="12" v-if="mostrarItensPadronizadosKit">
                <DataTable :tableTitle="'Produtos padronizados do Kit'" :tableHeader="headersItensKit" :tableRows="listaDeItensKit" :isKit="true"></DataTable>
              </v-col>
            </v-expand-transition>

            <v-expand-transition>
              <v-col cols="12" v-if="showSubestoquesField && !dispensaKit">
                <v-autocomplete label="Lista de Subestoques" :items="listaDeSubestoque" v-model="subestoqueSelecionadoDispensa" clearable></v-autocomplete>
              </v-col>
            </v-expand-transition>

            <v-expand-transition>
              <v-col cols="12" v-if="!dispensaKit && !mostrarAviso">
                <v-autocomplete label="Lista de Familias" :items="listaDeFamilias" v-model="familiaSelecionada" clearable></v-autocomplete>
              </v-col>
            </v-expand-transition>

            <v-expand-transition>
              <v-col cols="12" v-if="!dispensaKit && !mostrarAviso && !mostrarAvisoFamilia">
                <v-autocomplete label="Lista de Produtos" :items="listaDeMateriais" v-model="itemSelecionado"></v-autocomplete>
              </v-col>
            </v-expand-transition>

            <v-expand-transition>
              <v-col cols="12" v-if="!modalCustomSize.isView && !dispensaKit && mostrarAviso">
                <v-alert v-show="mensagemSubestoque.erro" transition="scale-transition" type="warning" text>{{ mensagemSubestoque.text }}</v-alert>
              </v-col>
            </v-expand-transition>

            <v-expand-transition>
              <v-col cols="12" v-if="!modalCustomSize.isView && !dispensaKit && !mostrarAviso && mostrarAvisoFamilia">
                <v-alert v-show="mensagemFamilia.erro" transition="scale-transition" type="warning" text>{{ mensagemFamilia.text }}</v-alert>
              </v-col>
            </v-expand-transition>

            <v-col cols="12">
              <v-card>
                <v-card-title>
                  <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line></v-text-field>
                </v-card-title>

                <v-data-table :headers="headersItens" :search="search" :items="modalCustomSize.actualEdit.listaDeItensEnviados" disable-sort>
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Produtos Dispensados</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>

                  <template v-slot:[`item.validade`]="{ item }">
                    <v-chip :color="corValidade(item.validade)" dark>{{ item.validade }}</v-chip>
                  </template>

                  <template v-slot:[`item.item.validade`]="{ item }">
                    <v-chip :color="corValidade(item.item.validade)" dark>{{ item.item.validade }}</v-chip>
                  </template>

                  <template v-slot:[`item.quantidade`]="props">
                    <v-text-field style="max-width:250px" v-model="props.item.quantidade" :rules="[rules.required]" label="Quantidade para Dispensar" single-line @keypress="(event) => filter(event)"></v-text-field>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small @click="deleteItemFromList(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
                      </template>
                      <span>Excluir</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </div>

      <div v-if="modalCustomSize.isView">
        <v-row>
          <v-col cols="12">
            <DataTable :tableTitle="'Produtos Dispensados para o Subestoque: ' + modalCustomSize.actualEdit.nomeSubestoque" :tableHeader="headersItensDispensados" :tableRows="modalCustomSize.actualEdit.listaDeItensEnviados"></DataTable>
          </v-col>
        </v-row>
      </div>
    </ModalCustomSize>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import DataTable from "@/components/DataTable2.vue";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import TipoImpressao from "../components/TipoImpressao";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal,
    TipoImpressao,
    AlertaSnackbar,
  },

  data: () => ({
    //Paginação
    pageDispensa: 1,
    searchDispensa: null,
    totalDispensa: null,
    //Fim da paginação
    rules: {
      required: (value) => !!value || "Requer o campo!",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },

    mensagemSubestoque: {
      erro: false,
      text: null,
    },

    mensagemFamilia: {
      erro: false,
      text: null,
    },

    showSkeletonTable: true,
    loading: false,
    isFormValid: false,
    search: "",
    dispensaKit: false,
    mostrarItensPadronizadosKit: false,
    mostrarAviso: false,
    mostrarAvisoFamilia: false,
    showSubestoquesField: false,

    snack: false,
    snackColor: "",
    snackText: "",
    pagination: {},

    //#region Cabeçalhos de Tabelas
    headers: [
      {
        text: "ID",
        value: "dispensaSubestoque.numeroDispensaSubestoque",
      },
      {
        text: "Nome Subestoque",
        value: "subestoque.nomeSubestoque",
      },
      {
        text: "Nome Unidade",
        value: "endereco.nomeEndereco",
      },
      {
        text: "Responsável pela Dispensa",
        value: "funcionario.nomeFuncionario",
      },
      {
        text: "Data Dispensa",
        value: "dispensaSubestoque.dataDispensa",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItens: [
      {
        text: "ID",
        value: "value",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Nome Produto",
        value: "nomeItem",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Qt. Total",
        value: "quantidadeAtual",
      },
      {
        text: "Qt. que deseja remover do Estoque (Digite Abaixo)",
        value: "quantidade",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensDispensados: [
      {
        text: "ID",
        value: "itemDispensa.numeroItemDispensaSubestoque",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      {
        text: "Nome Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Quantidade Dispensada",
        value: "itemDispensa.quantidadeDispensada",
      },
    ],

    headersItensKit: [
      {
        text: "ID",
        value: "numeroItemSistemaUnidade",
      },
      {
        text: "Nome Produto",
        value: "nomeItemSistema",
      },
      {
        text: "Qt. Padrão",
        value: "quantidade",
      },
    ],
    //#endregion

    modalCustomSize: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isView: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      actualEdit: {
        numeroEndereco: store.state.numeroEndereco,
        numeroDispensaSubestoque: null,
        numeroSubestoque: null,
        nomeSubestoque: null,
        dataDispensa: null,
        descricaoObservacao: null,
        listaDeItensEnviados: [],
        itensJaDispensados: [],
        descricaoTela: "dispensaSubestoques",
      },
    },

    modalImpressao: {
      modalAberta: false,
      conteudo: null,
    },

    //Array populado pela função inicializar
    listaDeDispensasSubestoques: [],
    listaDeSubestoques: [],
    listaDeMateriais: [],
    listaDeKits: [],
    listaDeItensKit: [],
    kitSelecionado: null,
    subestoqueSelecionado: null,
    itemSelecionado: null,
    subestoqueSelecionadoDispensa: null,
    listaDeSubestoque: [],
    listaDeFamilias: [
      {
        value: 1,
        text: "Medicações",
      },
      {
        value: 2,
        text: "Materiais",
      },
      {
        value: 3,
        text: "Psicotrópicos",
      },
      {
        value: 4,
        text: "Saneantes",
      },
      {
        value: 5,
        text: "Cosméticos",
      },
      {
        value: 6,
        text: "Nutrição ",
      },
      {
        value: 7,
        text: "Antimicrobianos",
      },
      {
        value: 8,
        text: "Amostra Grátis",
      },
      {
        value: 9,
        text: "Maleta de Emergência",
      },
      {
        value: 10,
        text: "Doação",
      },
      {
        value: 11,
        text: "Teste Rápido"
      },
      {
        value: 12,
        text: "USO INTERNO"
      }
    ],
    familiaSelecionada: null,
  }),

  created() {
    this.inicializar();
  },

  watch: {
    async subestoqueSelecionado() {
      this.modalCustomSize.actualEdit.numeroSubestoque = this.subestoqueSelecionado;
      if (this.subestoqueSelecionado && !this.modalCustomSize.isView) {
        this.mostrarItensDispensado = false;
        const subestoque = this.listaDeSubestoques.filter((subestoqueSelecionado) => subestoqueSelecionado.value == this.subestoqueSelecionado);

        this.modalCustomSize.actualEdit.nomeSubestoque = subestoque[0].text;
      } else {
        this.mostrarItensDispensado = false;
      }
    },

    async subestoqueSelecionadoDispensa() {
      this.familiaSelecionada = null;
      await this.listarItensDisponiveisNaUnidade(this.subestoqueSelecionadoDispensa, this.familiaSelecionada);
    },

    async familiaSelecionada() {
      await this.listarItensDisponiveisNaUnidade(this.subestoqueSelecionadoDispensa, this.familiaSelecionada);
    },

    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },

    itemSelecionado() {
      if (this.itemSelecionado) {
        this.alertaModal.tipo = "";
        this.alertaSnackbar.mostrar = false;

        const verificarItem = this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((item) => item.value == this.itemSelecionado);

        if (verificarItem.length <= 0) {
          const itemInsert = this.listaDeMateriais.filter((item) => item.value == this.itemSelecionado);

          this.modalCustomSize.actualEdit.listaDeItensEnviados.unshift(itemInsert[0]);
          this.itemSelecionado = "";
          this.modalCustomSize.isButtonsDisabled = true;
        } else {
          this.alertaModal.tipo = "erro";
          this.alertaModal.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaSnackbar.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaSnackbar.mostrar = true;
        }
      }
    },

    async dispensaKit() {
      if (this.dispensaKit) {
        await this.listaKits();
      } else {
        this.listaDeKits = [];
        this.kitSelecionado = null;
        this.subestoqueSelecionadoDispensa = null;
      }
    },

    async kitSelecionado() {
      if (this.kitSelecionado) {
        this.mostrarItensPadronizadosKit = false;
        await this.listaItensKit(this.kitSelecionado);
        await this.listaItensPadronizadosKit(this.kitSelecionado);
      } else {
        this.modalCustomSize.actualEdit.listaDeItensEnviados = [];
        this.mostrarItensPadronizadosKit = false;
      }
    },
  },

  methods: {
    //#region Funções de inicialização, é listado todas as informações necessarias ao entrar na tela
    async inicializar() {
      this.showSkeletonTable = true;
      try {
        await this.listaDispensaSubestoque();
      } catch (error) {
        console.log(error);
      }
    },

    async listaDispensaSubestoque() {
      try {
        let dispensas = await axios.put("dispensaSubestoque", { numeroEndereco: store.state.numeroEndereco, page: this.pageDispensa, search: this.searchDispensa }, this.config);
        if (!dispensas.data || dispensas.data.length > 0) {
          this.listaDeDispensasSubestoques = dispensas.data;
          this.totalDispensa = dispensas.data[0].dispensaSubestoque.total;
        }

        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error);
        this.showSkeletonTable = false;
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async updateSearch(search) {
      if (search) {
        this.searchDispensa = search;
        this.pageDispensa = 1;
        await this.listaDispensaSubestoque();
      } else {
        this.pageDispensa = 1;
      }
    },

    async updatePage(pagination) {
      this.pageDispensa = pagination.page;
      await this.listaDispensaSubestoque();
    },

    async listarTodosSubestoques() {
      try {
        let subestoques = await axios.put("subestoque", { numeroEndereco: store.state.numeroEndereco }, this.config);

        this.listaDeSubestoques = subestoques.data.map((subestoqueSelecionado) => {
          return {
            value: subestoqueSelecionado.numeroSubestoque,
            text: subestoqueSelecionado.nomeSubestoque,
          };
        });
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listaSubestoques() {
      try {
        let responseSubestoque = await axios.put("subestoque", { numeroEndereco: store.state.numeroEndereco }, this.config);

        this.listaDeSubestoque = responseSubestoque.data.map((row) => {
          return {
            value: row.numeroSubestoque,
            text: row.nomeSubestoque,
          };
        });

        if (this.listaDeSubestoque.length > 0) {
          this.showSubestoquesField = true;
        } else {
          this.showSubestoquesField = false;
        }
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listarItensDisponiveisNaUnidade(numeroSubestoque, indicadorStatusFamilia) {
      try {
        const responseItens = await axios.put("itemEstoqueUnidadedispensasubestoque", { numeroEndereco: store.state.numeroEndereco, numeroSubEstoque: numeroSubestoque, indicadorStatusFamilia: indicadorStatusFamilia, semVazios: true }, this.config);

        if (numeroSubestoque && !indicadorStatusFamilia && responseItens.data.length <= 0) {
          this.mostrarAviso = true;
          this.mensagemSubestoque.text = "Este subestoque não possuí produtos vinculados.";
          this.mensagemSubestoque.erro = true;
        } else if (indicadorStatusFamilia && responseItens.data.length <= 0) {
          this.mostrarAvisoFamilia = true;
          this.mensagemFamilia.text = "Esta familia não possuí produtos vinculados.";
          this.mensagemFamilia.erro = true;
        } else {
          this.mensagemSubestoque.erro = false;
          this.mensagemFamilia.erro = false;
          this.mostrarAviso = false;
          this.mostrarAvisoFamilia = false;
        }

        this.listaDeMateriais = responseItens.data.map((row) => {
          return {
            value: row.item.numeroItem,
            text: "Validade: " + row.item.validade + " " + row.nomeItemPadrao + " Lote: " + row.item.lote,
            nomeItem: row.nomeItemPadrao,
            lote: row.item.lote,
            validade: row.item.validade,
            quantidadeAtual: row.itemUnidade.quantidadeEstoqueItem,
            numeroItemSistemaUnidade: row.itemSistemaUnidade.itemSistemaUnidade.numeroItemSistemaUnidade,
            numeroItemUnidade: row.itemUnidade.numeroItemUnidade,
            indicadorStatusFamilia: row.item.indicadorStatusFamilia,
          };
        });
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listaKits() {
      try {
        let responseKit = await axios.put("kits", { numeroEndereco: store.state.numeroEndereco }, this.config);

        this.listaDeKits = responseKit.data.map((row) => {
          return {
            value: row.kit.numeroKit,
            text: row.kit.nomeKit,
          };
        });
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listaItensKit(numeroKit) {
      try {
        let responseItensKit = await axios.put("itensDetalhadosKit", { numeroKit: numeroKit }, this.config);

        this.modalCustomSize.actualEdit.listaDeItensEnviados = responseItensKit.data;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listaItensPadronizadosKit(numeroKit) {
      try {
        let responseItensKit = await axios.put("itensKit", { numeroKit: numeroKit }, this.config);

        responseItensKit.data.map((itemKitSelecionado) => {
          const filtarItensListados = this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((itemSelecionado) => itemSelecionado.numeroItemSistemaUnidade == itemKitSelecionado.numeroItemSistemaUnidade);
          let total = filtarItensListados.reduce(function(total, item) {
            return total + item.quantidade;
          }, 0);
          if (itemKitSelecionado.quantidade != total) {
            itemKitSelecionado.color = "red";
          } else {
            itemKitSelecionado.color = "green";
          }
        });

        this.listaDeItensKit = responseItensKit.data;
        this.mostrarItensPadronizadosKit = true;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },
    //#endregion

    //#region Deletar Itens lista
    deleteItemFromList(value) {
      value.quantidade = null;
      this.modalCustomSize.actualEdit.listaDeItensExcluidos.push(this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((item) => item.value == value.value));
      this.modalCustomSize.actualEdit.listaDeItensEnviados = this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((item) => item.value != value.value);

      if (this.modalCustomSize.actualEdit.listaDeItensEnviados.length == 0) {
        this.modalCustomSize.isButtonsDisabled = true;
      }
    },
    //#endregion

    //#region Função de inserção
    async insert() {
      this.modalCustomSize.isButtonsDisabled = true;
      this.modalCustomSize.isLoadingRequestDisable = true;
      try {
        if (this.modalCustomSize.actualEdit.listaDeItensEnviados.length > 0) {
          this.alertaModal.tipo = "";
          this.alertaSnackbar.mostrar = false;
          await axios.post("dispensaSubestoque", this.modalCustomSize.actualEdit, this.config);
          this.$socket.emit("insertUnidade", this.modalCustomSize.actualEdit);

          this.modalCustomSize.isOpen = false;
          this.inicializar();
        } else {
          this.alertaModal.texto = "Não foi possivel fazer a inserção, adicione produtos antes de fazer a Dispensa!";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Não foi possivel fazer a inserção, adicione produtos antes de fazer a Dispensa!";
          this.alertaSnackbar.mostrar = true;
          this.modalCustomSize.isButtonsDisabled = false;
        }
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
        this.modalCustomSize.isButtonsDisabled = false;
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
      }
    },
    //#endregion

    //#region Funções de popular e abrir modal
    async modalInsert() {
      this.loading = true;
      try {
        this.alertaModal.tipo = "";
        this.alertaSnackbar.mostrar = false;

        await this.listarTodosSubestoques();
        await this.listaSubestoques();
        await this.listarItensDisponiveisNaUnidade();

        this.search = "";

        this.modalCustomSize.actualEdit.numeroSubestoque = null;
        this.modalCustomSize.actualEdit.nomeSubestoque = null;
        this.modalCustomSize.actualEdit.descricaoObservacao = null;
        this.modalCustomSize.actualEdit.listaDeItensEnviados = [];
        this.modalCustomSize.actualEdit.listaDeItensExcluidos = [];
        this.subestoqueSelecionado = null;
        this.subestoqueSelecionadoDispensa = null;
        this.itemSelecionado = null;
        this.mostrarItensPadronizadosKit = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isView = false;
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.isButtonsVisible = true;
        this.modalCustomSize.buttonText = "Concluir";
        this.modalCustomSize.formTitle = "Nova Dispensa Subestoque";
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    async modalView(dispensaSelecionada) {
      this.loading = true;
      try {
        this.alertaModal.tipo = "";
        this.alertaSnackbar.mostrar = false;

        this.itemSelecionado = null;
        this.subestoqueSelecionadoDispensa = null;
        this.mostrarItensPadronizadosKit = false;

        this.modalCustomSize.actualEdit.numeroDispensaSubestoque = dispensaSelecionada.dispensaSubestoque.numeroDispensaSubestoque;
        this.modalCustomSize.actualEdit.numeroSubestoque = dispensaSelecionada.subestoque.numeroSubestoque;
        this.modalCustomSize.actualEdit.nomeSubestoque = dispensaSelecionada.subestoque.nomeSubestoque;
        this.modalCustomSize.actualEdit.descricaoObservacao = dispensaSelecionada.dispensaSubestoque.descricaoObservacao;

        const response = await axios.put("itensDispensadosSubestoque", { numeroDispensaSubestoque: dispensaSelecionada.dispensaSubestoque.numeroDispensaSubestoque }, this.config);
        this.modalCustomSize.actualEdit.listaDeItensEnviados = response.data;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isView = true;
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.isButtonsVisible = false;
        this.modalCustomSize.formTitle = "Visualizar Dispensa de Subestoque";
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    imprimir(conteudo) {
      this.modalImpressao.conteudo = conteudo;
      this.modalImpressao.modalAberta = true;
    },
    //#endregion

    //#region PDF
    async gerarPDF(conteudo) {
      let dataAtual = new Date().toISOString().substr(0, 10);
      let horasAtual = new Date();
      let formattedTime = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Sao_Paulo",
      }).format(horasAtual);

      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        info: {
          title: "Comprovante Entrega",
        },
        content: [
          { text: "Comprovante Entrega", style: "header" },
          {
            text: "Numero da Dispensa: " + conteudo.dispensaSubestoque.numeroDispensaSubestoque,
            style: "subheader",
          },
        ],
        styles: {
          header: {
            fontSize: 24,
            bold: true,
            alignment: "center",
            margin: [0, 32, 0, 8],
          },
          subheader: {
            fontSize: 16,
            bold: false,
            alignment: "center",
            margin: [0, 8, 0, 32],
          },
          textSignature: {
            fontSize: 16,
            bold: false,
            alignment: "center",
            margin: [0, 24, 0, 48],
          },
          bigSpace: {
            fontSize: 2,
            bold: false,
            alignment: "center",
            margin: [0, 200, 0, 8],
          },
          table: {
            alignment: "center",
            margin: [0, 32, 0, 56],
          },
          line: {
            alignment: "center",
            margin: [0, 2, 0, 2],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
          subtext: {
            fontSize: 14,
            bold: true,
            margin: [0, 24, 0, 4],
          },
          nameText: {
            margin: [0, 8, 0, 8],
            fontSize: 16,
          },
        },
        defaultStyle: {
          margin: [0, 1, 0, 1],
          fontSize: 12,
          // alignment: 'justify'
        },
      };

      const response = await axios.put("itensDispensadosSubestoque", { numeroDispensaSubestoque: conteudo.dispensaSubestoque.numeroDispensaSubestoque }, this.config);
      const listaDeItens = response.data;

      if (listaDeItens.length > 0) {
        let tabela = [
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "Número", style: "tableHeader" },
                  { text: "Lote", style: "tableHeader" },
                  { text: "Nome Item", style: "tableHeader" },
                  { text: "Validade", style: "tableHeader" },
                  { text: "Quantidade Dispensada", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        for (let item of listaDeItens) {
          tabela[0].table.body.push([item.itemDispensa.numeroItemDispensaSubestoque, item.item.lote, item.itemSistema.nomeItemSistema, item.item.validade, item.itemDispensa.quantidadeDispensada]);
        }

        docDefinition.content.push(tabela);
      } else {
        let itens = { text: "Sem produtos dispensados!", style: "subtext" };
        docDefinition.content.push(itens);
      }

      docDefinition.content.push({
        text: "Recebi os Itens Constantes Neste Cupom",
        style: "textSignature",
      });
      docDefinition.content.push({
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: 760,
            y2: 0,
            lineWidth: 1,
            style: "line",
          },
        ],
      });
      docDefinition.content.push({
        text: "Beneficiario: " + conteudo.subestoque.nomeSubestoque,
        style: "nameText",
      });
      if (conteudo.endereco.descricaoEndereco) {
        docDefinition.content.push({
          text: "End.: " + conteudo.endereco.descricaoEndereco + ", " + conteudo.endereco.descricaoNumeroIdentificador,
        });
      }
      if (conteudo.endereco.descricaoBairro) {
        docDefinition.content.push({
          text: "Bairro: " + conteudo.endereco.descricaoBairro,
        });
      }
      docDefinition.content.push({ text: "Municipio: Itu - SP" });
      if (conteudo.endereco.descricaoCep) {
        docDefinition.content.push({
          text: "CEP: " + conteudo.endereco.descricaoCep,
        });
      }
      docDefinition.content.push({
        text: "Data: " + this._formatStringInBrazilianDateFormat(dataAtual) + " Hora: " + formattedTime,
      });
      docDefinition.content.push({ text: ".", style: "bigSpace" });

      pdfMake.createPdf(docDefinition).open();

      this.modalImpressao.modalAberta = false;
    },

    async gerarNota(conteudo) {
      let dataAtual = new Date().toISOString().substr(0, 10);
      let horasAtual = new Date();
      let formattedTime = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Sao_Paulo",
      }).format(horasAtual);

      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        pageOrientation: "landscape",
        info: {
          title: "Comprovante Entrega",
        },
        content: [
          { text: "Comprovante Entrega", style: "header" },
          {
            text: "Numero da Dispensa: " + conteudo.dispensaSubestoque.numeroDispensaSubestoque,
            style: "subheader",
          },
        ],
        styles: {
          header: {
            fontSize: 42,
            bold: true,
            alignment: "center",
            margin: [0, 32, 0, 8],
          },
          subheader: {
            fontSize: 32,
            bold: false,
            alignment: "center",
            margin: [0, 8, 0, 32],
          },
          textSignature: {
            fontSize: 28,
            bold: false,
            alignment: "center",
            margin: [0, 24, 0, 96],
          },
          bigSpace: {
            fontSize: 2,
            bold: false,
            alignment: "center",
            margin: [0, 200, 0, 8],
          },
          table: {
            alignment: "center",
            margin: [0, 56, 0, 56],
          },
          line: {
            alignment: "center",
            margin: [0, 2, 0, 2],
          },
          tableHeader: {
            bold: true,
            fontSize: 22,
            color: "black",
          },
          subtext: {
            fontSize: 28,
            bold: true,
            margin: [0, 24, 0, 4],
          },
          nameText: {
            margin: [0, 16, 0, 16],
            fontSize: 28,
          },
        },
        defaultStyle: {
          margin: [0, 1, 0, 1],
          fontSize: 28,
          // alignment: 'justify'
        },
      };

      const response = await axios.put("itensDispensadosSubestoque", { numeroDispensaSubestoque: conteudo.dispensaSubestoque.numeroDispensaSubestoque }, this.config);
      const listaDeItens = response.data;

      if (listaDeItens.length > 0) {
        let tabela = [
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "Número", style: "tableHeader" },
                  { text: "Lote", style: "tableHeader" },
                  { text: "Nome Item", style: "tableHeader" },
                  { text: "Validade", style: "tableHeader" },
                  { text: "Quantidade Dispensada", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        for (let item of listaDeItens) {
          tabela[0].table.body.push([item.itemDispensa.numeroItemDispensaSubestoque, item.item.lote, item.itemSistema.nomeItemSistema, item.item.validade, item.itemDispensa.quantidadeDispensada]);
        }

        docDefinition.content.push(tabela);
      } else {
        let itens = { text: "Sem produtos dispensados!", style: "subtext" };
        docDefinition.content.push(itens);
      }

      docDefinition.content.push({
        text: "Recebi os Itens Constantes Neste Cupom",
        style: "textSignature",
      });
      docDefinition.content.push({
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: 760,
            y2: 0,
            lineWidth: 1,
            style: "line",
          },
        ],
      });
      docDefinition.content.push({
        text: "Beneficiario: " + conteudo.subestoque.nomeSubestoque,
        style: "nameText",
      });
      if (conteudo.endereco.descricaoEndereco) {
        docDefinition.content.push({
          text: "End.: " + conteudo.endereco.descricaoEndereco + ", " + conteudo.endereco.descricaoNumeroIdentificador,
        });
      }
      if (conteudo.endereco.descricaoBairro) {
        docDefinition.content.push({
          text: "Bairro: " + conteudo.endereco.descricaoBairro,
        });
      }
      docDefinition.content.push({ text: "Municipio: Itu - SP" });
      if (conteudo.endereco.descricaoCep) {
        docDefinition.content.push({
          text: "CEP: " + conteudo.endereco.descricaoCep,
        });
      }
      docDefinition.content.push({
        text: "Data: " + this._formatStringInBrazilianDateFormat(dataAtual) + " Hora: " + formattedTime,
      });
      docDefinition.content.push({ text: ".", style: "bigSpace" });

      pdfMake.createPdf(docDefinition).open();
      this.modalImpressao.modalAberta = false;
    },
    //#endregion

    //#region Formatação de Data
    _formatStringInBrazilianDateFormat(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },

    corValidade(data) {
      if (data) {
        var ano = data.split("/")[2];
        var mes = data.split("/")[1];
        var dia = data.split("/")[0];
        // var dia2  = dia.substring(0,2)

        const dataFormatada = ano + "-" + ("0" + mes).slice(-2) + "-" + dia;

        const dias = this.verificarDias(dataFormatada);

        if (store.state.numeroEndereco == 127 || store.state.numeroEndereco == "127" || store.state.numeroEndereco == 124 || store.state.numeroEndereco == "124") {
          if (dias > 90) {
            return "green";
          } else if (dias > 0 && dias <= 90) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        } else {
          if (dias > 30) {
            return "green";
          } else if (dias > 0 && dias <= 30) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        }
      }
    },

    verificarDias(data) {
      const dateAtual = new Date().toISOString().substr(0, 10);
      const daterecive = data;

      const diferenceOfDates = new Date(daterecive) - new Date(dateAtual);
      const daysOfDiference = Math.ceil(diferenceOfDates / (1000 * 60 * 60 * 24));

      return daysOfDiference;
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    //#endregion
  },
};
</script>
